import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { getImageUrl } from '@/lib/image-url';

type MapComponentProps = {
  locationName: string;
  lat?: number;
  lng?: number;
};

const MapComponent: React.FC<MapComponentProps> = ({
  locationName,
  lat = 48.625785661884734,
  lng = -4.527178282987814
}) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<L.Map | null>(null);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    const map = L.map(mapRef.current, {
      scrollWheelZoom: false,
      attributionControl: true,
    }).setView([lat, lng], 15);

    // Supprime l'icône Leaflet, garde Jawg
    map.attributionControl.setPrefix('');
    map.attributionControl.addAttribution('<a href="https://jawg.io" target="_blank">© Jawg</a> © OSM');

    L.tileLayer(
      'https://tile.jawg.io/62401b13-9d2b-4e30-805f-96474142e912/{z}/{x}/{y}{r}.png?access-token=G7DkFt4zpAFJggJJAugjuPTLgmqb4E9j9sXQpbeL5aGKHSXUbCP5h5WfvQ8FWI5f&lang=fr&text-size=0.5',
      {
        maxZoom: 20,
      }
    ).addTo(map);

    const customIcon = L.icon({
      iconUrl: getImageUrl("pin.png"),
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -40],
    });

    L.marker([lat, lng], { icon: customIcon }).addTo(map);

    mapInstanceRef.current = map;

    return () => {
      map.remove();
      mapInstanceRef.current = null;
    };
  }, [lat, lng]);

  return (
    <div className="w-full h-80 md:h-[28rem] rounded-xl overflow-hidden shadow-md">
      <div ref={mapRef} style={{ width: '100%', height: '100%' }} />
    </div>
  );
};

export default MapComponent;
